import { isAvatarSrc, thumbnailMediumBlue } from '@utils/thumbnails'
import { colors, fontSize, size } from '@styles/theme'
import styled from '@emotion/styled'
import clamp from 'clamp-js'

import ProfileNavigateAvatar from '@elements/ProfileNavigateAvatar'

const DisplayContainer = styled.div`
  display: flex;
  padding: ${size(1.5)};
  border-bottom: 0.5px solid rgba(47, 51, 54);
`

const IconPanel = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-right: ${size(1)};
  width: 
`

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${size(5)}
`

const ContentPanel = styled.div`
  width: 100%;
  padding-right: ${size(2)};
`

const Profiles = styled.div`
  display: flex;
  align-items: center;
  gap: ${size(0.75)};
  padding-bottom: ${size(0.5)};
`

const Title = styled.div`
  // NOTE: 0.95rem font-size is between sm and md
  font-size: 0.95rem;
  padding: ${size(0.75)} 0;
`

const Body = styled.div`
  color: grey;
  font-weight: 400;
  // NOTE: 0.95rem font-size is between sm and md
  font-size: 0.95rem;
  line-height: ${size(2.5)};

  p {
    margin: 0;
    color: grey;
  }

  a {
    color: grey !important;
  }
`

const ShowText = styled.span`
  display: flex;
  align-items: center;

  margin-left: -1px;
  padding-top: ${size(0.5)};

  font-size: ${fontSize('sm')};
  color: ${colors.statusColors.right_now('primary')};
`

const NotificationDisplay = ({ Icon, users=[], title='', body='', showAll=false, clickCallback }) => {

  const renderProfiles = () => users.slice(0, 5).map((user, i) => (
    <ProfileNavigateAvatar
      key={i}
      src={thumbnailMediumBlue(user?.socialMedia?.thumbnail, user?.defaultAvatar)}
      uuid={user?.uuid}
      toNearby={false}
      style={{
        filter: isAvatarSrc('medium', user?.socialMedia?.thumbnail, user?.defaultAvatar) && 'grayscale(100%) contrast(120%)',
        height: size(5),
        width: size(5),
      }}
    />
  ))

  const handleBodyClick = (e) => {
    e.preventDefault()
  }

  const handleContainerClick = (e) => {
    e.preventDefault()
    if (clickCallback) clickCallback()
  }

  return (
    <DisplayContainer onClick={handleContainerClick} >
      <IconPanel>
        <IconWrapper>
          <Icon size={size(3)} />
        </IconWrapper>
      </IconPanel>
      <ContentPanel>
        <Profiles>
          {renderProfiles()}
        </Profiles>
        <Title>
          {title}
        </Title>
        <Body
          ref={node => node && clamp(node, { clamp: 8 })}
          dangerouslySetInnerHTML={{ __html: body || '' }}
          onClick={handleBodyClick}
        />
        {showAll && <ShowText>show all</ShowText>}
      </ContentPanel>
    </DisplayContainer>
  )
}

export default NotificationDisplay
